import React from 'react';
import DataTableContainer from './DataTableContainer';

const Dashboard = (props) => {
    return <DataTableContainer {...props} /> 
};

export default Dashboard;
